<template>
  <div class="flex-col page">
    <div class="flex-row justify-center relative group">
      <img
        @click="$router.back()"
        class="image pos"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=73da474f9f0a9d2a13c183e0f2ed8f88.png"
      />
      <span class="self-start text">修改脚本</span>
    </div>
    <div class="flex-col group_2 mt-37">
      <div class="flex-col justify-start section">
        <div class="flex-col items-start group_3" contenteditable="true" ref="editableDiv">
        <span class="font text_2">
          宝爸宝妈们，好消息来啦！2024年学平险保障范围全面扩大啦！
          <br/>
        </span>
          <span class="font text_3">
          孩子上学，安全和健康是头等大事。学平险一直是家长们为孩子保驾护航的“小能手”，如今它变得更强大了！
          <br/>
        </span>
          <span class="font text_4">
          今年的学平险不仅涵盖了意外伤害、疾病医疗等常见保障，还新增了许多实用的保障内容。比如，一些产品增加了校园内意外事故的赔付范围，甚至对一些特殊疾病也有了更全面的保障。无论是小磕小碰，还是突发疾病，都能给孩子更贴心的守护。
          <br/>
        </span>
          <span class="font text_5">
          更让人惊喜的是，保障升级的同时，保费并没有大幅增加，性价比超高！这对于家长们来说，无疑是最大的福音。
          <br/>
        </span>
          <span class="font text_6">
          孩子的成长路上，风险处无不在。2024年学平险的升级，就像给孩子的校园生活加了一道“安全锁”。家长们，赶紧了解一下，为孩子选择一份更全面的保障吧！
        </span>
        </div>
      </div>
      <div class="flex-col justify-start items-center text-wrapper mt-23" @click="checkContent"><span class="text_7">开始拍摄</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      sensitiveWords: ['敏感词1', '敏感词2', '敏感词3'], // 敏感词数组
    };
  },
  methods: {
    checkContent() {
      const content = this.$refs.editableDiv.innerText;
      const hasSensitiveWords = this.sensitiveWords.some(word => content.includes(word));
      console.log(content, hasSensitiveWords)
      if (hasSensitiveWords) {
        alert('输入的内容包含敏感词，请修改后再试。');
      } else {
        this.$router.push({name: 'shipinpaishe'});
      }
    }
  },
};
</script>

<style scoped lang="less">
.mt-37 {
  margin-top: 37px;
}

.mt-23 {
  margin-top: 23px;
}

.page {
  padding: 14px 0 43px;
  background-color: rgb(17, 17, 17);
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;

  .group {
    padding: 0 16px 10px;

    .image {
      border-radius: 5px;
      width: 24px;
      height: 24px;
    }

    .pos {
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
    }

    .text {
      color: rgb(255, 255, 255);
      font-size: 18px;
      font-family: 思源黑体;
      font-weight: 700;
      line-height: 17px;
    }
  }

  .group_2 {
    padding: 0 28px;

    .section {
      padding: 25px 0 0;
      background-color: rgba(108, 108, 108, 0.5);
      border-radius: 20px;

      .group_3 {
        margin: 0 13px;
        padding-bottom: 138px;
        overflow: hidden;
        height: 570px;

        .font {
          font-size: 18px;
          font-family: 思源黑体;
          line-height: 22px;
          color: rgb(249, 249, 249);
        }

        .text_2 {
          width: 320px;
        }

        .text_3 {
          margin-top: 6px;
          width: 320px;
        }

        .text_4 {
          margin-top: 6px;
          width: 320px;
        }

        .text_5 {
          margin-top: 6px;
          width: 320px;
        }

        .text_6 {
          margin-top: 6px;
          width: 320px;
        }
      }
    }

    .text-wrapper {
      padding: 12px 0 18px;
      background-color: rgb(85, 239, 227);
      border-radius: 16px;
      overflow: hidden;

      .text_7 {
        color: rgb(17, 17, 17);
        font-size: 22px;
        font-family: Barlow;
        font-weight: 600;
        line-height: 20.5px;
        letter-spacing: 2px;
      }
    }
  }
}
</style>
